<template>
  <div v-if="show" class="px-4 py-2 rounded relative flex items-center" :class="[mainColor]" role="alert">
    <div v-if="hasCustomContent">
      <slot name="custom-content" />
    </div>
    <div v-else class="flex items-center">
      <div v-if="hasIcon" class="slot-icon pr-4">
        <slot name="icon"></slot>
      </div>
      <span class="block sm:inline mr-4"> {{ text }} </span>
    </div>
    <div v-if="closeIcon" @click="closeAlert">
      <zt-icon class="absolute top-0 right-0 px-4 py-3 cursor-pointer" :class="{ 'bottom-0': !hasCustomContent }"
        name="times" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ztAlert',
  inheritAttrs: false,
  props: {
    text: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: 'primary'
    },
    duration: {
      type: Number,
      default: 0
    },
    closeIcon: {
      type: Boolean,
      default: true
    },
    filled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: true
    }
  },
  computed: {
    mainColor() {
      if (this.color && this.filled) return `zt-alert-main-fill-${this.color}`
      if (this.color && !this.filled) return `zt-alert-main-${this.color}`
      return null
    },
    hasIcon() {
      return !!this.$slots.icon
    },
    hasCustomContent() {
      return !!this.$slots['custom-content']
    }
  },
  methods: {
    closeAlert() {
      this.show = false
      this.$emit('afterClosed')
    },
    fade() {
      setTimeout(() => {
        this.show = false
        this.$emit('afterClosed')
      }, 1000 * this.duration)
    }
  },
  mounted() {
    if (this.duration) {
      this.fade()
    }
  }
}
</script>

<style scoped lang="css" src="../../../../../src/styles/components/ztAlert.css" />
